import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-7 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-brand-400 mb-4">99prop.com</h3>
            <p className="text-gray-300 text-sm mb-4">
              AI-Powered Property Valuation & Fast-Track Sale Service for NCR Region
            </p>
            <p className="text-gray-400 text-sm">
              Ghaziabad, Indirapuram, Vaishali, Vasundhara & Noida
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/?start=true" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Check Property Value
                </Link>
              </li>
              <li>
                <Link 
                  to="/buy-property" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Buy Property
                </Link>
              </li>
              <li>
                <Link 
                  to="/buyer-strategy" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Buyer Strategy
                </Link>
              </li>
              <li>
                <Link 
                  to="/about" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Sell Your Property */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Sell Your Property</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/sell-flat-in-indirapuram" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Sell Flat in Indirapuram
                </Link>
              </li>
              <li>
                <Link 
                  to="/sell-flat-in-vaishali" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Sell Flat in Vaishali
                </Link>
              </li>
              <li>
                <Link 
                  to="/sell-flat-in-vasundhara" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Sell Flat in Vasundhara
                </Link>
              </li>
            </ul>
          </div>

          {/* Buy 2BHK */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Buy 2BHK</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/buy-2bhk-in-indirapuram" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Buy 2BHK in Indirapuram
                </Link>
              </li>
              <li>
                <Link 
                  to="/buy-2bhk-in-vaishali" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Buy 2BHK in Vaishali
                </Link>
              </li>
              <li>
                <Link 
                  to="/buy-2bhk-in-vasundhara" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Buy 2BHK in Vasundhara
                </Link>
              </li>
            </ul>
          </div>

          {/* Buy 3BHK */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Buy 3BHK</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/buy-3bhk-in-indirapuram" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Buy 3BHK in Indirapuram
                </Link>
              </li>
              <li>
                <Link 
                  to="/buy-3bhk-in-vaishali" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Buy 3BHK in Vaishali
                </Link>
              </li>
              <li>
                <Link 
                  to="/buy-3bhk-in-vasundhara" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Buy 3BHK in Vasundhara
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/terms" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link 
                  to="/disclaimer" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Disclaimer
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy-policy" 
                  onClick={handleClick}
                  className="text-gray-300 hover:text-brand-400 transition text-sm"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>📧 Email: info@99prop.com</li>
              <li>
                📞 Phone:{' '}
                <a 
                  href="tel:+919891979097" 
                  className="hover:text-brand-400 transition"
                >
                  +91 9891 97 90 97
                </a>
              </li>
              <li>📍 NCR, India</li>
            </ul>
          </div>
        </div>

        {/* Bottom Section with Disclaimer */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          {/* Disclaimer */}
          <div className="mb-6 text-center">
            <p className="text-gray-400 text-sm leading-relaxed max-w-4xl mx-auto">
              <span className="font-semibold text-gray-300">Disclaimer:</span> 99prop.com, a platform of 99Prop Capital, is an independent real estate valuation and acquisition company. We are not a property listing portal and are not affiliated with any other real estate platform.
            </p>
          </div>
          
          {/* Copyright */}
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} 99prop.com. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
